// extracted by mini-css-extract-plugin
export default {"brand":"Logo_brand__vaB2B","container":"Logo_container__TL3TG","logo":"Logo_logo__nQeiy","sublogo":"Logo_sublogo__PowsJ","link":"Logo_link__bUTWX"};